// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--jK2YG","text":"_02712f2b3b--text--qe0oS","info-icon":"_02712f2b3b--info-icon--eUMUD","rate":"_02712f2b3b--rate--tqpGH"};